import axios from "axios";
import Vue from "vue";
import authHeader from "@/services/auth-header";
import config from "@/data/config";
import model from "@/data/model";

const API_URL = config.baseURL;
const myModel = model.baptis;

export const umatArsip = {
   namespaced: true,
   state: {
      data: [],
      item: { ...myModel },
   },
   getters: {
      // countAll: (state) => {return state.data.length},
      countAll(state) {
         return state.data.length;
      },
      getById: (state) => (id) => {
         return state.data.find((data) => data.id === id);
      },
   },
   actions: {
      async getAll({ commit, rootState }) {
         rootState.isLoading = true;
         await axios
            .get(`${API_URL}umat_arsip`, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  commit("SET_DATA", response.data);
                  rootState.isLoading = false;
               },
               () => {
                  rootState.isLoading = false;
               }
            );
      },
      async getItem({ rootState }, id) {
         rootState.isLoading = true;
         return await axios
            .get(`${API_URL}umat_arsip/${id}`, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      async insert({ commit, rootState }, data) {
         rootState.isLoading = true;
         return await axios
            .post(`${API_URL}umat_arsip`, data, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  commit("PUSH_ITEM", response.data);
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      async update({ commit, rootState }, data) {
         rootState.isLoading = true;
         return await axios
            .put(`${API_URL}umat_arsip/${data.umat.uid}`, data, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  commit("CHANGE_ITEM", response.data);
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      async delete({ rootState }, id) {
         rootState.isLoading = true;
         return await axios
            .delete(`${API_URL}umat_arsip/${id}`, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  // commit("REMOVE_ITEM", id);
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      async download({ rootState }, id) {
         rootState.isLoading = true;
         return await axios({
            method: "get",
            url: `${API_URL}umat_arsip/${id}`,
            headers: authHeader(),
            responseType: "arraybuffer",
         }).then(
            (response) => {
               // commit("REMOVE_ITEM", id);
               rootState.isLoading = false;
               return Promise.resolve(response);
            },
            (error) => {
               rootState.isLoading = false;
               return Promise.reject(error);
            }
         );
      },
      setItem({ commit }, item) {
         commit("SET_ITEM", item);
      },
      resetItem({ commit }) {
         const item = { ...myModel };
         commit("SET_ITEM", item);
      },
   },
   mutations: {
      SET_DATA(state, data) {
         state.data = data;
      },
      SET_ITEM(state, item) {
         state.item = item;
      },
      PUSH_ITEM(state, item) {
         state.data.push(item);
      },
      CHANGE_ITEM(state, payload) {
         console.log(payload);
         const index = state.data.findIndex((item) => item.id === payload.id);
         if (index !== -1) {
            Vue.set(state.data, index, payload);
         }
      },
      REMOVE_ITEM(state, id) {
         var i = state.data.findIndex((data) => data.id == id);

         state.data.splice(i, 1);
      },
   },
};
